import Vue from 'vue';
import { MutationTree } from 'vuex';

import baseWorkflowStore from '../../store/baseWorkflowStore';
import initialState from './initialState';
import { ApplicationMapsSeedingSoyState, Calculation, WorkflowVariety } from './types';

const mutations: MutationTree<ApplicationMapsSeedingSoyState> = {
  ...baseWorkflowStore.mutations,

  reset(state: ApplicationMapsSeedingSoyState): void {
    const newState: ApplicationMapsSeedingSoyState = initialState();
    Object.entries(newState).forEach(([key, value]) => {
      Vue.set(state, key, value);
    });
  },
  fetchVarieties(state: ApplicationMapsSeedingSoyState): void {
    Vue.set(state.varieties, 'fetching', true);
  },
  setVarieties(state: ApplicationMapsSeedingSoyState, varieties: WorkflowVariety[]): void {
    Vue.set(state.varieties, 'fetching', false);
    Vue.set(state.varieties, 'current', varieties);
  },
  setVarietiesFetching(state: ApplicationMapsSeedingSoyState, fetching: boolean): void {
    Vue.set(state.varieties, 'fetching', fetching);
  },
  setCalculation(state: ApplicationMapsSeedingSoyState, calculation: Calculation): void {
    Vue.set(state, 'calculation', calculation);
  },
  setCalculationField(state: ApplicationMapsSeedingSoyState, data): void {
    Vue.set(state.calculation, data.key, data.value);
  },
  setQuantisationCode(state: ApplicationMapsSeedingSoyState, quantisationCode: string): void {
    Vue.set(state, 'selectedQuantisationCode', quantisationCode);
  },
};

export default mutations;
